/* global Office, document, console */
import * as $ from "jquery";
import * as md5 from "js-md5";
import moment from "moment";
import * as officeutils from "./../utils/officeutils";
import * as utils from "./../utils/utils";
import * as htmlutils from "./../utils/htmlutils";
import * as MESSAGES from "./../MESSAGES";
//import * as logger from "./../logger/logger";
import * as CONSTANTS from "./../CONSTANTS";

let _mailbox;
let email;

let body;
let attachments;

Office.onReady((info) => {
  $.ajaxSetup({
    statusCode: {
      401: function (data) {
        showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, data.statusText, data.status), false);
      },
      403: function (data) {
        showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, data.statusText, data.status), false);
      },
      404: function (data) {
        showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, data.statusText, data.status), false);
      },
      500: function (data) {
        showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, data.statusText, data.status), false);
      },
      503: function (data) {
        showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, data.statusText, data.status), false);
      },
    },
  });

  if (info.host === Office.HostType.Outlook) {
    fadeOutAlert();
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    officeutils.fillUsernamePassword($("#username"), $("#password"));
    _mailbox = Office.context.mailbox;
    setBody()
      .then((result) => {
        //var limited= utils.limit(result, 1000);
        body = result;
      })
      .catch((result) => {
        console.error(result);
      });

    
    setAttachments()
      .then((result) => {
        attachments = result;
      })
      .catch((result) => {
        console.error(result);
      });
    
    _mailbox.item.loadCustomPropertiesAsync(customPropsCallback);
    configShowButton();
  }

  htmlutils.fillItemBox(
    $("#item-created"),
    $("#item-subject"),
    $("#item-from"),
    $("#item-to"),
    $("#item-cc"),
    $("#item-body"),
    $("#item-attachments")
  );
  document.getElementById("run").onclick = run;
});

export function run() {
  fadeOutAlert();
  const item = Office.context.mailbox.item;
  let itemType = "inbound";
  let status = "read";
  if (Office.context.mailbox.userProfile.emailAddress === Office.context.mailbox.item.from.emailAddress) {
    itemType = "outbound";
    status = "sent";
  }

  var date_sent_received = moment(item.dateTimeCreated).format("YYYY-MM-DD HH:mm:ss");
  email = {
    email_type: itemType,
    entity_record: [
      { name: "name", value: item.normalizedSubject },
      //Y-m-d H:i:s.
      { name: "date_sent_received", value: date_sent_received },
      { name: "date_entered", value: date_sent_received },
      { name: "from_addr_name", value: item.from.emailAddress },
      { name: "to_addrs", value: utils.fillAddress(item.to) },
      { name: "cc_addrs", value: utils.fillAddress(item.cc) },
      { name: "bcc_addrs", value: utils.fillAddress(item.bcc) },
      { name: "description_html", value: body },
      { name: "status", value: status },
    ],
    attachments: utils.parseJson(attachments),
  };

  var valid = htmlutils.validateUsernamePassword(
    $("#username").val(),
    $("#password").val(),
    "alert-username",
    "alert-password"
  );

  if (valid) {
    officeutils.saveUsernamePassword($("#username").val(), $("#password").val());
    var hash = md5($("#password").val());
    var userInfo = { user_name: $("#username").val(), password: hash };
    $.ajax({
      type: "post",
      url: CONSTANTS.LOGIN_URL,
      data: JSON.stringify(userInfo),
      contentType: "application/json; charset=utf-8",
      traditional: true,
      success: function (data) {
        let bearer;
        bearer = data.bearerToken;
        if (bearer == null) {
          showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, data.description, data.code), false);
        } else {
          $.ajax({
            type: "post",
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", "Bearer " + bearer);
              xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
            },
            url: CONSTANTS.ADD_EMAIL_URL,
            data: JSON.stringify(email),
            contentType: "application/json; charset=utf-8",
            traditional: true,
            success: function (data) {
              var datafirst = "";
              if (Array.isArray(data)) datafirst = data[0];
              else datafirst = data;
              if (datafirst.code === 200) {
                showAlert(MESSAGES.EMAIL_SUCCESS_MESSAGES, true);
                officeutils.updateProperty(CONSTANTS.SENT, true);
              } else {
                showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, datafirst.description, datafirst.code), false);
              }
            },
            error: function (data) {
              console.error(data);
              showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, data, "500"), false);
            },
          });
        }
      },
      error: function (data) {
        console.error(data);
        showAlert(MESSAGES.parse(MESSAGES.EMAIL_ERROR_MESSAGES, data, "500"), false);
      },
    });
  }
}

export function configShowButton() {
  var panelButton = document.getElementById("show");
  var panelContent = document.getElementById("panel-container");
  panelButton.addEventListener("click", function () {
    // eslint-disable-next-line no-undef
    new fabric["Panel"](panelContent);
  });
}

export function showAlert(text, success) {
  console.log(success)
  var panelMessage = document.getElementById("panel-message");
  $("#alert").removeClass("ms-MessageBar--error");
  $("#alert").removeClass("ms-MessageBar--success");
  $("#alert-message").text("");

  if(success)
    $("#alert").addClass("ms-MessageBar--success");
  else 
    $("#alert").addClass("ms-MessageBar--error");
    
  $("#alert-message").text(text);
  
    new fabric["Panel"](panelMessage);

}

function customPropsCallback(asyncResult) {
  if (asyncResult.status == Office.AsyncResultStatus.Failed) {
    console.error(MESSAGES.CANNOT_LOAD_CUSTOM_PROPS);
  } else {
    officeutils.setCustoProps(asyncResult.value);
    officeutils.updateProperty(CONSTANTS.SENT, false);
    if (officeutils.getProperty(CONSTANTS.SENT)) {
      showAlert(MESSAGES.EMAIL_SENT_MESSAGES, true);
      document.getElementById("run").disabled = true;
    } else {
      document.getElementById("run").disabled = false;
    }
  }
}

function setBody() {
  return new Promise(function (resolve, reject) {
    try {
      const item = Office.context.mailbox.item;
      item.body.getAsync("html", function (result) {
        resolve(result.value);
      });
    } catch (error) {
      reject(error);
    }
  });
}

function setAttachments() {
  const item = Office.context.mailbox.item;

  console.debug("Numero allegati totali:", item.attachments.length);

  return new Promise((resolve, reject) => {
    // filtro gli inline
    const filtered = item.attachments.filter(att => att.isInline === false);

    console.debug("Allegati filtrati (no inline):", filtered.length);

    if (filtered.length === 0) {
      console.debug("Nessun allegato valido trovato → risolvo con []");
      return resolve([]);
    }

    // creo un array di Promises
    const promises = filtered.map(att => {
      console.debug("Elaboro allegato:", att.name, "id:", att.id);

      return new Promise((res, rej) => {
        item.getAttachmentContentAsync(att.id, function (content) {
          if (content.status === Office.AsyncResultStatus.Failed) {
            console.debug("Errore su", att.name, ":", content.error.message);
            return rej(content.error);
          }


          switch (content.value.format) {
            case Office.MailboxEnums.AttachmentContentFormat.Base64:
              const filename = { name: "filename", value: att.name };
              const file = { name: "file", value: content.value.content };
              res([filename, file]);
              break;
            case Office.MailboxEnums.AttachmentContentFormat.Eml:
              res(null);
              break;
            case Office.MailboxEnums.AttachmentContentFormat.ICalendar:
              res(null);
              break;
            case Office.MailboxEnums.AttachmentContentFormat.Url:
              res(null);
              break;
            default:
              console.debug("→ Formato non riconosciuto:", content.value.format);
              res(null);
          }
        });
      });
    });

    Promise.all(promises)
      .then(results => {
        const attachments = results.filter(r => r !== null);
        console.debug("Totale allegati elaborati:", attachments.length);
        resolve(JSON.stringify(attachments));
      })
      .catch(err => {
        console.debug("Errore generale in setAttachments:", err);
        reject(err);
      });
  });
}

export function fadeOutAlert() {
  const nodes = document.getElementsByClassName("alert-container");
  for (let i = 0; i < nodes.length; i++) {
    nodes[i].style.display = "none";
  }
}
